import * as tslib_1 from "tslib";
import { map, takeUntil } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import * as auth from '../../actions/account';
import * as fromAuth from '../../reducers';
import { ContainerBase } from '../../../core/base/container-base';
var ActivateContainer = /** @class */ (function (_super) {
    tslib_1.__extends(ActivateContainer, _super);
    function ActivateContainer(store, route) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.route = route;
        route.params.pipe(takeUntil(_this.destroyed$), map(function (params) { return new auth.Activate(params['token']); }))
            .subscribe(_this.store);
        _this.working$ = store.pipe(select(fromAuth.isWorking), takeUntil(_this.destroyed$));
        _this.success$ = store.pipe(select(fromAuth.isSuccessful), takeUntil(_this.destroyed$));
        _this.error$ = store.pipe(select(fromAuth.getActivateError), takeUntil(_this.destroyed$));
        return _this;
    }
    return ActivateContainer;
}(ContainerBase));
export { ActivateContainer };
